(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["levayo-category-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('levayo-category-rail')) {
    customElements.define('levayo-category-rail', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('[data-feature-track]');
        this.previous = this.querySelector('[data-feature-prev]');
        this.next = this.querySelector('[data-feature-next]');
        if (!this.track || !this.previous || !this.next) return;
        const update = () => {
          const remaining = this.track.scrollWidth - this.track.clientWidth - Math.abs(this.track.scrollLeft);
          this.previous.disabled = Math.abs(this.track.scrollLeft) <= 4;
          this.next.disabled = remaining <= 4;
        };
        const move = direction => {
          const step = this.track.firstElementChild?.getBoundingClientRect().width || this.track.clientWidth;
          const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
          this.track.scrollBy({ left: direction * rtl * (step + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.previous.addEventListener('click', () => move(-1), options);
        this.next.addEventListener('click', () => move(1), options);
        this.track.addEventListener('scroll', update, { ...options, passive: true });
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
